/* COVA search drawer: predictive search through the Section Rendering API */
(function () {
  'use strict';
  function ready(fn) { if (window.CV && window.CV.register) fn(); else window.addEventListener('load', fn); }
  ready(function () {
    CV.register('[data-cv-search]', function (root) {
      var input = root.querySelector('[data-cv-search-input]');
      var results = root.querySelector('[data-cv-search-results]');
      var fallback = root.querySelector('[data-cv-search-default]');
      var status = root.querySelector('[data-cv-search-status]');
      var timer = null, last = '', controller = null;
      if (!input || !results) return;
      var base = (window.cvRoutes && window.cvRoutes.predictiveSearch) || '/search/suggest';
      var section = results.getAttribute('data-section') || 'cova-predictive-search';

      function show(term) {
        if (term.length < 2) {
          results.querySelectorAll('.cv-search__found').forEach(function (n) { n.remove(); });
          if (fallback) fallback.hidden = false;
          return;
        }
        if (controller) controller.abort();
        controller = 'AbortController' in window ? new AbortController() : null;
        results.classList.add('is-loading');
        if (status) status.textContent = results.getAttribute('data-loading-label') || '';
        var url = base + '?q=' + encodeURIComponent(term) + '&section_id=' + encodeURIComponent(section) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, controller ? { signal: controller.signal, credentials: 'same-origin' } : { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var found = doc.querySelector('.cv-search__found');
          results.querySelectorAll('.cv-search__found').forEach(function (n) { n.remove(); });
          if (found) { results.appendChild(found); if (fallback) fallback.hidden = true; }
          results.classList.remove('is-loading');
          if (status && found) status.textContent = found.getAttribute('data-cv-found') + ' results';
        }).catch(function (err) { if (!err || err.name !== 'AbortError') results.classList.remove('is-loading'); });
      }
      input.addEventListener('input', function () {
        var term = input.value.trim();
        if (term === last) return;
        last = term;
        window.clearTimeout(timer);
        timer = window.setTimeout(function () { show(term); }, 250);
      });
      root.addEventListener('cv:open', function () { window.setTimeout(function () { input.focus(); }, 80); });
      root.addEventListener('cv:close', function () { input.value = ''; last = ''; show(''); });
    });
  });
})();
